export const environment = {
  production: true,
  showTestMessage: true,
  baseUrl: './usilenceApi'
};



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/environments/environment.ts